module.exports = __webpack_public_path__ + "static/img/logo.d8859b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/logo.png
// module id = 6PsS
// module chunks = 12